
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-dark text-offWhite pt-16 pb-8 border-t border-grayMid/20">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12 text-left">
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <img src="/align-logo.png" alt="Align Product Studio Logo" className="h-10 w-10 brand-logo" />
              <h2 className="text-2xl font-bold text-offWhite">
                <span className="text-cyanPrimary">Align</span> Product Studio
              </h2>
            </div>
            <p className="text-offWhite/70 mb-4">
              Fractional Digital Product Leadership for Mission-Driven Startups
            </p>
            <p className="text-offWhite/70 italic">Where vision + execution align.</p>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold mb-4 text-offWhite">Pages</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-offWhite/70 hover:text-cyan-400 transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/approach" className="text-offWhite/70 hover:text-cyan-400 transition-colors">
                  Approach
                </Link>
              </li>
              <li>
                <Link to="/insights" className="text-offWhite/70 hover:text-cyan-400 transition-colors">
                  Insights
                </Link>
              </li>
              <li>
                <Link to="/clients" className="text-offWhite/70 hover:text-cyan-400 transition-colors">
                  Clients
                </Link>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold mb-4 text-offWhite">Connect</h3>
            <div className="space-y-3">
              <a href="https://www.linkedin.com/in/addyspiller/" target="_blank" rel="noopener noreferrer" className="flex items-center text-offWhite/70 hover:text-cyan-400 transition-colors group">
                <svg className="w-5 h-5 mr-3 group-hover:scale-110 transition-transform" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                </svg>
                LinkedIn
              </a>
            </div>
          </div>
        </div>
        
        <div className="border-t border-grayMid/20 pt-8 text-center text-offWhite/50 text-sm">
          <p>© {currentYear} Align Product Studio. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
